import ecotorqueImage from "../assets/img/ECOTORQUE.png";
import ewonImage from "../assets/img/EWON.png";
import ottoBoxImage from "../assets/img/OTTO_BOX.png";
import noPlcImage from "../assets/img/NON_PLC.png";

/**
 * Structural upper bounds per system type (IBM-462), mirroring the backend's
 * system-type config (installed-base-backend docs/system-types-architecture.md).
 * Used to pre-validate the type picker for untyped systems: a type is only
 * selectable when the current structure fits its bounds. The backend rejects
 * violations with SYSTEM_STRUCTURE_EXCEEDS_TARGET_LIMITS as the backstop.
 */
export const SYSTEM_TYPES = [
    { value: "NON_PLC",   number: 1, label: "Group of pumps",                  image: noPlcImage,     maxPressureLines: 5,  maxAssets: 30 },
    { value: "OTTO_BOX",  number: 2, label: "Group of pumps with system data", image: ottoBoxImage,   maxPressureLines: 6,  maxAssets: 30 },
    { value: "EWON",      number: 3, label: "Central control system (eWon)",   image: ewonImage,      maxPressureLines: 30, maxAssets: 30 },
    { value: "ECOTORQUE", number: 4, label: "ECOTORQUE Master Control",        image: ecotorqueImage, maxPressureLines: 1,  maxAssets: 30 },
];

/**
 * Numbered display title, e.g. "2: Group of pumps with system data". The number is
 * composed at render time so the plain names stay the i18next keys.
 */
export const getSystemTypeLabel = (
    value: string | null | undefined,
    t: (key: string) => string,
): string => {
    if (!value) return t("Not configured");
    const entry = SYSTEM_TYPES.find(s => s.value === value);
    if (!entry) return value;
    return `${entry.number}: ${t(entry.label)}`;
};

/**
 * PLC-backed system types are monitored through the external Busch IoT portal and are
 * shown via an embedded iframe. NON_PLC systems and unconfigured (null) systems are
 * managed in our own Hero dashboard (banner + pressure lines) instead.
 */
export const PLC_SYSTEM_TYPES = ["ECOTORQUE", "EWON", "OTTO_BOX"];

export const isPlcSystemType = (value: string | null | undefined): boolean =>
    !!value && PLC_SYSTEM_TYPES.includes(value);

/** Types offered in the "Connect IoT system" modal — gateway-backed only (NON_PLC is not connectable). */
export const GATEWAY_SYSTEM_TYPES = SYSTEM_TYPES.filter(t => isPlcSystemType(t.value));
